export default __webpack_public_path__ + "static/media/noassignments.f5635653.svg";